<template>
  <div>
    <main class="main">
      <div class="breadcrumb-wrap">
        <div class="banner">
          <img class="bg-img bg-top" src="/assets/images/bg/bg-header-001.jpg" alt="banner" />
          <div class="container-lg">
            <div class="breadcrumb-box">
              <div class="heading-box">
                <h1>{{ slugTitle }}</h1>
              </div>
              <!-- <ol class="breadcrumb">
                        <li><a href="/">Inicio</a></li>
                        <li>
                        <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                        </li>
                        <li class="current"><a href="#" onclick="return false;">Tags</a></li>
                    </ol> -->
            </div>
          </div>
        </div>
      </div>
      <FilterProduct
        v-if="slug_tags"
        :key="slug_tags"
        :slug_tags="slug_tags"
        :show_categorie="1"
        :show_marca="1"
      />
    </main>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import FilterProduct from './layouts/FilterProduct.vue'
import { useMeta } from 'vue-meta'
import { computed, watch } from 'vue'
export default {
  name: 'FilterOffer',
  components: { FilterProduct },

  setup() {
    const route = useRoute()

    const slug_tags = computed(() => route.query.text || null)
    const slugTitle = computed(() => {
      if (!slug_tags.value) return ''
      const capital = slug_tags.value.charAt(0).toUpperCase() + slug_tags.value.slice(1)
      return capital === 'Nuevo' ? 'Novedades' : capital
    })

    const { meta } = useMeta({
      title: slugTitle.value,
      htmlAttrs: { lang: 'es' },
    })

    // actualiza dinámicamente cuando cambia el query
    watch(slugTitle, (newVal) => {
      meta.title = newVal || 'Mi Tienda'
    })

    return { slug_tags, slugTitle }
  },
}
</script>
